import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import "./Access.css"
import Button from '../components/Button'
import CustomInput from "../components/CustomInput";
import VerticalList from "../components/VerticalList";
import TitleText from "../components/TitleText";
import {urlFor, TARGET_ACCESS, postJson, RequestAccess} from "../utils/comms.js"
import { setAccessToken } from "../utils/cookies";

function Access() {
    const [accessCode, setAccessCode] = useState('');
    const [loadingAccess, setLoadingAccess] = useState(false);

    const handleInputChange = (event) => {
        setAccessCode(event.target.value);
    };

    const navigate = useNavigate();

	const handleSubmit = async () => {
        if (loadingAccess)
            return;

        setLoadingAccess(true);

        try {
            const tagetUrl = urlFor(TARGET_ACCESS);
            const requestAccess = new RequestAccess(accessCode);
            await postJson(tagetUrl, requestAccess);
            setAccessToken(accessCode);
            navigate("/home")
        } catch (err) {
            alert(err.response.error);
        } finally {
            setLoadingAccess(false);
        }
    };

    return (
        <div>
            <VerticalList>
                <TitleText
                    text="Access"
                />
                <CustomInput
                    placeholder={"access code"}
                    onChange={handleInputChange}
                />
                <Button
                    text={"Continue"}
                    onClick={handleSubmit}
                />
            </VerticalList>
        </div>
    )
}

export default Access;

